import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaYoutube,
  FaGlobe,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaGoogle,
  FaSearch,
  FaAd,
  FaNewspaper,
  FaTv,
  FaUserFriends,
  FaBriefcase,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaCommentAlt,
  FaWalking,
  FaRobot,
} from "react-icons/fa";
import { SiZalo } from "react-icons/si";

const SourceIcon = ({ sourceName, size = 16 }) => {
  if (!sourceName) {
    // Return a default icon if sourceName is not provided
    return <FaGlobe size={size} title="Unknown Source" />;
  }

  const lowerSource = sourceName.toLowerCase();

  // Function to determine which icon to use
  const getIcon = () => {
    // Check for walk-in first since it might conflict with other conditions
    if (
      lowerSource.includes("walkin") ||
      lowerSource.includes("walk-in") ||
      lowerSource.includes("walk in")
    ) {
      return <FaWalking size={size} color="#32CD32" title={sourceName} />;
    }
    if (
      lowerSource.includes("website") ||
      lowerSource.includes("web") ||
      (lowerSource.includes("b2c") &&
        !lowerSource.includes("walkin") &&
        !lowerSource.includes("walk-in") &&
        !lowerSource.includes("walk in"))
    ) {
      return <FaGlobe size={size} color="#007bff" title={sourceName} />;
    }
    if (lowerSource.includes("facebook") || lowerSource.includes("fb")) {
      return <FaFacebook size={size} color="#3b5998" title={sourceName} />;
    }
    if (lowerSource.includes("instagram") || lowerSource.includes("insta")) {
      return <FaInstagram size={size} color="#E1306C" title={sourceName} />;
    }
    if (lowerSource.includes("twitter") || lowerSource.includes("tweet")) {
      return <FaTwitter size={size} color="#1DA1F2" title={sourceName} />;
    }
    if (lowerSource.includes("linkedin") || lowerSource.includes("li")) {
      return <FaLinkedin size={size} color="#0077B5" title={sourceName} />;
    }
    if (lowerSource.includes("youtube") || lowerSource.includes("yt")) {
      return <FaYoutube size={size} color="#FF0000" title={sourceName} />;
    }
    if (lowerSource.includes("whatsapp") || lowerSource.includes("wa")) {
      return <FaWhatsapp size={size} color="#25D366" title={sourceName} />;
    }
    if (lowerSource.includes("zalo")) {
      return <SiZalo size={size} color="#0068FF" title={sourceName} />;
    }
    if (lowerSource.includes("google") || lowerSource.includes("gmb")) {
      return <FaGoogle size={size} color="#4285F4" title={sourceName} />;
    }
    if (lowerSource.includes("chatbot") || lowerSource.includes("ct")) {
      return <FaRobot size={size} color="#4285F4" title={sourceName} />;
    }
    if (
      lowerSource.includes("phone") ||
      lowerSource.includes("call") ||
      lowerSource.includes("telephone")
    ) {
      return <FaPhone size={size} color="#34B7F1" title={sourceName} />;
    }
    if (
      lowerSource.includes("email") ||
      lowerSource.includes("mail") ||
      lowerSource.includes("gmail")
    ) {
      return <FaEnvelope size={size} color="#D44638" title={sourceName} />;
    }
    if (
      lowerSource.includes("search") ||
      lowerSource.includes("organic") ||
      lowerSource.includes("seo")
    ) {
      return <FaSearch size={size} color="#FFA500" title={sourceName} />;
    }
    if (
      lowerSource.includes("ad") ||
      lowerSource.includes("ppc") ||
      lowerSource.includes("google ads")
    ) {
      return <FaAd size={size} color="#FBBC05" title={sourceName} />;
    }
    if (lowerSource.includes("newspaper") || lowerSource.includes("print")) {
      return <FaNewspaper size={size} color="#555" title={sourceName} />;
    }
    if (lowerSource.includes("tv") || lowerSource.includes("television")) {
      return <FaTv size={size} color="#9932CC" title={sourceName} />;
    }
    if (
      lowerSource.includes("referral") ||
      lowerSource.includes("word of mouth")
    ) {
      return <FaUserFriends size={size} color="#20B2AA" title={sourceName} />;
    }
    if (
      lowerSource.includes("event") ||
      lowerSource.includes("exhibition") ||
      lowerSource.includes("trade show")
    ) {
      return <FaCalendarAlt size={size} color="#FF6347" title={sourceName} />;
    }
    if (lowerSource.includes("visit") || lowerSource.includes("store")) {
      return <FaMapMarkerAlt size={size} color="#32CD32" title={sourceName} />;
    }
    if (
      lowerSource.includes("chat") ||
      lowerSource.includes("messenger") ||
      lowerSource.includes("live chat")
    ) {
      return <FaCommentAlt size={size} color="#6495ED" title={sourceName} />;
    }
    if (
      lowerSource.includes("business") ||
      lowerSource.includes("corporate") ||
      lowerSource.includes("b2b")
    ) {
      return <FaBriefcase size={size} color="#4682B4" title={sourceName} />;
    }

    // Fallback for any other source: show first two letters as an icon
    const words = sourceName.split(/\s+/).filter((word) => word.length > 0);
    let initials = "";

    if (words.length === 0) {
      initials = "??";
    } else if (words.length === 1) {
      initials = words[0].substring(0, 2).toUpperCase();
    } else {
      initials = (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }

    initials = initials.padEnd(2, "?").substring(0, 2);

    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: "#6c757d",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: size * 0.5,
          fontWeight: "bold",
          lineHeight: 1,
        }}
        title={sourceName}
      >
        {initials}
      </div>
    );
  };

  return getIcon();
};

export default SourceIcon;
